import { CityFoodRO } from '@routellers/types/dist/city-food/city-food.ro';
import { CreateCityFoodDto } from '@routellers/types/dist/city-food/create-city-food.dto';
import { UpdateCityFoodDto } from '@routellers/types/dist/city-food/update-city-food.dto';
import { UpsertCityFoodLocaleDto } from '@routellers/types/dist/city-food/upsert-city-food-locale.dto';
import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';

import { ApiMethodDeclaration } from '..';

const query: ApiMethodDeclaration<QueryDto, QueryRO<CityFoodRO>> = (params) => ({
    url: '/admin/city-foods',
    method: 'GET',
    params,
});

const getOne: ApiMethodDeclaration<number, CityFoodRO> = (id) => ({
    url: `/admin/city-foods/${id}`,
    method: 'GET',
});

const create: ApiMethodDeclaration<{ data: CreateCityFoodDto }, CityFoodRO> = ({ data }) => ({
    url: '/admin/city-foods',
    method: 'POST',
    data,
});

const update: ApiMethodDeclaration<{ id: number; data: UpdateCityFoodDto }, CityFoodRO> = ({
    id,
    data,
}) => ({
    url: `/admin/city-foods/${id}`,
    method: 'PATCH',
    data,
});

const upsertLocale: ApiMethodDeclaration<{ id: number; data: UpsertCityFoodLocaleDto }, CityFoodRO> =
    ({ id, data }) => ({
        url: `/admin/city-foods/${id}/locales`,
        method: 'PATCH',
        data,
    });

const remove: ApiMethodDeclaration<number, { ok: true }> = (id) => ({
    url: `/admin/city-foods/${id}`,
    method: 'DELETE',
});

export const cityFoodsApiDeclaration = {
    query,
    getOne,
    create,
    update,
    upsertLocale,
    remove,
};
